import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { type Location, useLocation } from 'react-router';
import { useRouter } from '../components/contexts/RouterContextManager';

const adminMenuItems = [
    {
        name: 'consoleLayout:menuItems.dashboard',
        path: '/admin',
    },
    {
        name: 'consoleLayout:menuItems.dashboard',
        path: '/admin/',
    },
    {
        name: 'consoleLayout:menuItems.dashboard',
        path: '/admin/overview',
    },
    {
        name: 'consoleLayout:menuItems.dashboard',
        path: '/admin/dashboard',
    },
    {
        name: 'consoleLayout:menuItems.applications',
        path: '/admin/applications',
    },
    {
        name: 'consoleLayout:menuItems.reservations',
        path: '/admin/reservations',
    },
    {
        name: 'consoleLayout:menuItems.insurances',
        path: '/admin/insurances',
    },
    {
        name: 'consoleLayout:menuItems.leads',
        path: '/admin/leads',
    },
    {
        name: 'consoleLayout:menuItems.appointments',
        path: '/admin/appointments',
    },
    {
        name: 'consoleLayout:menuItems.mobilitybookings',
        path: '/admin/mobilitybookings',
    },
    {
        name: 'consoleLayout:menuItems.tradeIns',
        path: '/admin/tradeIns',
    },
    {
        name: 'consoleLayout:menuItems.customers',
        path: '/admin/customers',
    },
    {
        name: 'consoleLayout:menuItems.giftVouchers',
        path: '/admin/giftCodes',
    },
    {
        name: 'consoleLayout:menuItems.promoCodes',
        path: '/admin/promoCodes',
    },
    {
        name: 'consoleLayout:menuItems.labels',
        path: '/admin/labels',
    },
    {
        name: 'consoleLayout:menuItems.events',
        path: '/admin/events',
    },
    {
        name: 'consoleLayout:menuItems.configurators',
        path: '/admin/configurators',
    },
    {
        name: 'consoleLayout:menuItems.banners',
        path: '/admin/banners',
    },
    {
        name: 'consoleLayout:menuItems.webpages',
        path: '/admin/webpages',
    },
    {
        name: 'consoleLayout:menuItems.mobilities',
        path: '/admin/mobilityoptions',
    },
    {
        name: 'consoleLayout:menuItems.makes',
        path: '/admin/vehicles/makes',
    },
    {
        name: 'consoleLayout:menuItems.models',
        path: '/admin/vehicles/models',
    },
    {
        name: 'consoleLayout:menuItems.subModels',
        path: '/admin/vehicles/submodels',
    },
    {
        name: 'consoleLayout:menuItems.variants',
        path: '/admin/vehicles/variants',
    },
    {
        name: 'consoleLayout:menuItems.inventory',
        path: '/admin/inventories',
    },
    {
        name: 'consoleLayout:menuItems.finderVehicles',
        path: '/admin/finderVehicles',
    },
    {
        name: 'consoleLayout:menuItems.financeProducts',
        path: '/admin/financeProducts',
    },
    {
        name: 'consoleLayout:menuItems.insuranceProducts',
        path: '/admin/insuranceProducts',
    },
    {
        name: 'consoleLayout:menuItems.cts',
        path: '/admin/cts',
    },
    {
        name: 'consoleLayout:menuItems.audiCalculation',
        path: '/admin/audiCalculation',
    },
    {
        name: 'consoleLayout:menuItems.consents',
        path: '/admin/consents',
    },
    {
        name: 'consoleLayout:menuItems.maintenance',
        path: '/admin/maintenance',
    },
    {
        name: 'consoleLayout:menuItems.dealers',
        path: '/admin/dealers',
    },
    {
        name: 'consoleLayout:menuItems.companyandcountry',
        path: '/admin/companies',
    },
    {
        name: 'consoleLayout:menuItems.banks',
        path: '/admin/banks',
    },
    {
        name: 'consoleLayout:menuItems.insurers',
        path: '/admin/insurers',
    },
    {
        name: 'consoleLayout:menuItems.modules',
        path: '/admin/system/modules',
    },
    {
        name: 'consoleLayout:menuItems.routers',
        path: '/admin/system/routers',
    },
    {
        name: 'consoleLayout:menuItems.languages',
        path: '/admin/system/languages',
    },

    {
        name: 'consoleLayout:menuItems.users',
        path: '/admin/accesses/users',
    },
    {
        name: 'consoleLayout:menuItems.roles',
        path: '/admin/accesses/roles',
    },
    {
        name: 'consoleLayout:menuItems.userGroups',
        path: '/admin/accesses/userGroups',
    },
];
const retrieveURL = (location: Location) => {
    const pathName = location.pathname.split('/').slice(1);

    // just `/admin` only
    if (pathName.length === 1) {
        return `/${pathName[0]}`;
    }

    const originalPathName = location.pathname;
    if (
        originalPathName.includes('accesses') ||
        originalPathName.includes('system') ||
        originalPathName.includes('vehicles')
    ) {
        return `/${pathName[0]}/${pathName[1]}/${pathName[2]}`;
    }

    return `/${pathName[0]}/${pathName[1]}`;
};

const AdminMetaData = () => {
    const { t } = useTranslation('consoleLayout');
    const location = useLocation();
    const router = useRouter();
    const [title, setTitle] = useState<string>('');
    const systemName = t('consoleLayout:defaultCompany');

    useEffect(() => {
        const domURL = retrieveURL(location);
        const featureTitle = t(adminMenuItems.find(item => item.path.toUpperCase() === domURL.toUpperCase()).name);
        const menuItemTitle = `${systemName} : ${featureTitle}`;
        setTitle(menuItemTitle);
    }, [location.pathname, setTitle]);

    return (
        <Helmet>
            <title>{title}</title>
        </Helmet>
    );
};

export default AdminMetaData;
